let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6LQfT")).then(() => parcelRequire('lkPLc'));